import React, { useEffect, useState } from 'react'
import styles from './UploadStories.module.scss'
import Header from '../../components/Header/Header'
import ScrollToTop from '../../components/Hooks/ScrollToTop'
import StoryUploadButtons from '../Stories2/StoryUploadButtons'
import { useNavigate } from 'react-router-dom'
import { FaAngleLeft } from "react-icons/fa6";
import classes from '../Stories2/StoryWrapper.module.scss'

function UploadStories() {
    const navigate = useNavigate()

    const [isPostUploadOpen, setIsPostUploadOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [ownRel, setOwnRel] = useState(0);

    const onClose = () => {
        navigate('/Home', { state: { storyUploaded: true } });
    };

    return (
        <div className="App">
            <div className="MainContainer">
                <ScrollToTop />
                {!isPostUploadOpen && (<Header />)}

                <div className={`${styles.Container} ${styles.Stories}`}>
                    {!isMobile && (
                        <div className={styles.BackButton}>
                            <button onClick={() => { navigate('/Home') }}>
                                <FaAngleLeft />
                            </button>
                        </div>
                    )}
                    <div className={classes.StoryWrapper}>
                        <StoryUploadButtons setStoryPopup={onClose} setOwnRel={setOwnRel} setIsHeaderOpen={setIsPostUploadOpen} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadStories


